jQuery(document).ready(function($) {
	
	function stickTableHeader(tableWrapper) {
		if ($(window).width()>=650) return;
		var table = tableWrapper.find('table');
		var tableHeader = table.find('thead');
		tableWrapper.css('padding-top', tableHeader.height());
		tableHeader.css('width', table.width() + 100);
		tableHeader.css('top', $('header.header').outerHeight());
		var leftOffset = table.offset().left + (((tableWrapper.find('.table-inner-wrapper').offset().left - table.offset().left))) - 2;
		tableHeader.attr('data-left-offset', leftOffset);
		tableHeader.css('left', leftOffset);
		tableHeader.find('th').each(function(index) {
			var newWidth = $(this).innerWidth() + 10;
			tableHeader.find('th:nth-child(' + (index + 1) + ')').css('min-width', newWidth);
			table.find('tr td:nth-child(' + (index + 1) + ')').css('min-width', newWidth);
		});
		tableWrapper.addClass('sticky-header');
	}

	function unstickTableHeader(tableWrapper) {
		if (!tableWrapper.hasClass('sticky-header')) return;
		tableWrapper.removeClass('sticky-header');
		var table = tableWrapper.find('table');
		var tableHeader = table.find('thead');
		tableWrapper.css('padding-top', 0);
		tableHeader.css('width', 'auto');
		tableHeader.css('top', 'auto');
		tableHeader.css('left', 'auto');
		tableHeader.find('th').each(function(index) {
			var newWidth = $(this).innerWidth() - 10;
			tableHeader.find('th:nth-child(' + (index + 1) + ')').css('min-width', newWidth);
			table.find('tr td:nth-child(' + (index + 1) + ')').css('min-width', newWidth);
		});
		if ($(window).width()>=650) {
			table.find('th, td').css('min-width', 'auto');
		}
	}

	var tableWaypoints = Array();
	$('.table-outer-wrapper').each(function() {
		var waypoint = new Waypoint.Inview({
			element: $(this),
			enter: function(direction) {
				//console.log('waypoint enter ' + direction);
				var tableWrapper = $(this.element);
				if (direction==='up') {
					stickTableHeader(tableWrapper);
				}
			},
			entered: function(direction) {
				//console.log('waypoint entered ' + direction);
				var tableWrapper = $(this.element);
				if (direction==='up') {
					unstickTableHeader(tableWrapper);
				} 
			},
			exited: function(direction) {
				//console.log('waypoint exited ' + direction);
				var tableWrapper = $(this.element);
				if (direction==='down') {
					unstickTableHeader(tableWrapper);
				}
			},
			exit: function(direction) {
				//console.log('waypoint exit ' + direction);
				var tableWrapper = $(this.element);
				if (direction==='down') {
					stickTableHeader(tableWrapper);
				}
			}
		});
	});

	$('.table-inner-wrapper').scroll(function(e) {
		var tableHeader = $(this).find('thead');
		var originalLeftOffset = parseInt(tableHeader.attr('data-left-offset'));

		tableHeader.css('left', ($(this).scrollLeft() * -1) + (originalLeftOffset));
		//animate({left: -1 * (originalLeftOffset)}, 10);
	});
});